
<template>
    <div class='column is-4-desktop is-6-tablet is-12-mobile'>
        <div class='card reference'>
            <div class='card-image is-hoverable' @click="modalIsActive = true">
                <figure class='image is-square'>
                    <img :src="cdnUrl + reference.media_path" :alt="reference.title">
                </figure>
            </div>

            <div class='card-content is-hoverable' @click="modalIsActive = true">
                <div class="content">
                    <p>{{reference.title}}</p>
                </div>
            </div>

            <footer class="card-footer" v-if="currentAccountIsSameAs(student) || isEmployee">
                <a href="#" @click.prevent="toggleEditModal"
                   class="card-footer-item has-text-info">{{$t('global.actions.edit')}}</a>

                <edit-reference v-if="editModalIsActive" :reference="reference"
                  @updated="() => {
                    reloadReferences();
                    toggleEditModal();
                  }"
                  @cancel="toggleEditModal"/>

                <a href="#" @click.prevent="toggleDeleteModal"
                   class="card-footer-item has-text-danger">{{$t('global.actions.delete')}}</a>

                <delete-reference v-if="deleteModalIsActive" :reference="reference"
                   @deleted="reloadReferences"
                   @cancel="toggleDeleteModal"/>
            </footer>
        </div>

        <b-modal :active.sync="modalIsActive" :width="640" scroll="keep">
            <div class="card">
                <div class="card-image">
                    <figure class="image is-square">
                        <img :src="cdnUrl + reference.media_path" :alt="reference.title">
                    </figure>
                </div>

                <div class="card-content">
                    <div class="media">
                        <div class="media-content">
                            <p class="title is-4">{{reference.title}}</p>
                        </div>
                    </div>

                    <div class="content">
                        <p>{{reference.text}}</p>

                        <a v-if="reference.link" class="button is-primary"
                           :href="reference.link">Se mere</a>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .reference {
        display: flex;
        flex-direction: column;
        height: 100%;

        .is-hoverable {
            cursor: pointer;
        }

        .card-content {
            padding: 1rem;
        }

        .card-image {
            background-color: #e3e3e3;

            img {
                object-fit: contain;
            }
        }

        .cart-footer {
            margin-top: auto;
        }
    }
</style>

<script>
    import AccountMixin from '@/global/mixins/AccountMixin';
    import DeleteReference from '@/taskflex/students/components/profile/references/DeleteReference';
    import EditReference from '@/taskflex/students/components/profile/references/EditReference';
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                modalIsActive: false,
                deleteModalIsActive: false,
                editModalIsActive: false,
            };
        },

        props: {
            reference: {
                type: Object,
                required: true,
            },

            student: {
                type: Object,
                required: true,
            },
        },

        computed: {
            ...mapGetters('auth', [
                'isEmployee',
            ]),
        },

        mixins: [AccountMixin],

        methods: {
            reloadReferences() {
                this.$eventHub.$emit('students.profile.update');
            },

            toggleEditModal() {
                this.editModalIsActive = !this.editModalIsActive;
            },

            toggleDeleteModal() {
                this.deleteModalIsActive = !this.deleteModalIsActive;
            },
        },

        components: {
            DeleteReference,
            EditReference,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/profile/references/Reference.vue